<template>
  <div class="">
    <Breadcrumb :title="$t('miga.SelectChannel')" />
    <HeadingBox :title="$t('selectchannel.title')" :description="$t('selectchannel.description')" />
    <DatosIntroducidos />
    <ListBox :loading="loading" :items="channels" title="name" description="description" icons_attribute="icon" :onSelect="onSelect" :heading="$t('selectchannel.title')" />
    <NavButton anterior="SelectService" />
  </div>
</template>
<script>
import Vue from 'vue'
import HeadingBox from '../components/HeadingBox'
import Breadcrumb from '../components/Breadcrumb'
import DatosIntroducidos from '../components/DatosIntroducidos'
import ListBox from '../components/ListBox'
import NavButton from '../components/NavButton'
import Session from "@/session/Session.js";

export default {
  name: "SelectChannel",
  components: {
    HeadingBox,
    Breadcrumb,
    DatosIntroducidos,
    ListBox,
    NavButton
  },
  data: () => {
    return {
      service: Session.getServicePoint(),
      channels: [],
      loading: false
    };
  },
  beforeDestroy() {
    window.removeEventListener('language.changed', this.init);
  },
  mounted() {
    window.addEventListener("language.changed", () => Vue.nextTick(this.init));
    this.init();
  },
  methods: {
    init () {
      this.channels.splice(0, this.channels.length)

      this.loading = true
      // si se cambia el lenguaje, no se actualiza. nextTick tampoco parece solucionarlo, setTimeout si ..
      let component = this
      setTimeout( ()=> {
        if (component.service.supportsOffice) component.channels.push({
          id: 9000,
          name: component.$t('selectchannel.presencialtitle'),
          description: component.$t('selectchannel.presencialdescr'),
          icon: ['fas fa-people-arrows']
        });
        if (component.service.supportsCallMe) component.channels.push({
          id: 9001,
          name: component.$t('selectchannel.teltitle'),
          description: component.$t('selectchannel.teldescr'),
          icon: ['fa fa-phone']
        });
        if (component.service.supportsVideoconference) component.channels.push({
          id: 9002,
          name: component.$t('selectchannel.videotitle'),
          description: component.$t('selectchannel.videodescr'),
          icon: ['fa fa-tv']
        });
        component.loading = false
      }, 250)

    },
    onSelect(s) {
      Session.setServiceChannel(s);
      this.$router.push({ name: 'RGPD' });
    },
  },
};
</script>

<style>
.queue {
  color: white;
  background-color: #37474f;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.font75pct {
  font-size: 80%;
}
</style>
